<template>
  <BaseModal id="modalFilterCategories" title="Categories">
    <div v-for="category in categories" :key="category.id">
      <FilterCategories
        :category="category"
        :filter-categories="filterCategories"
        :is-modal-open-after-applied="isModalOpenAfterApplied"
        :sub-categories-old="subCategoriesOld"
        @emitSelectedSubCategories="getSelectedSubCategoriesFromEmit"
        @resetIsModalOpenAfterApplied="resetIsModalOpenAfterApplied"
      />
    </div>

    <template slot="modal-footer">
      <b-button variant="link" class="btn-link-dark" @click="hide()"> Cancel </b-button>
      <b-button
        variant="success"
        :disabled="!allSelectedCondition.length && !subCategoriesOld.length"
        @click="submitFilterCategories()"
      >
        Apply
      </b-button>
    </template>
  </BaseModal>
</template>

<script>
import Category from '@/models/Category';
import FilterCategories from './FilterCategories';

import { BaseModal } from '@/components/base-components';

export default {
  name: 'ModalFilterCategories',

  components: {
    FilterCategories,
    BaseModal
  },

  props: {
    resetModal: {
      type: Boolean,
      default: false
    },
    /**
     * Use old value to track change of applied value
     */
    filterCategories: {
      type: [Array],
      default: () => []
    },

    /**
     * If the page has this value, means user is in edit page
     */
    subCategoriesOld: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      /**
       * TEMPORARY > identify type of modal
       *
       * @type {String}
       */
      modalType: null,

      /**
       * Main categories that recieve from fetching
       *
       * @type {Array}
       */
      categories: [],

      /**
       * Get value from emit selectSubcategories
       *
       * Use to be base selected values
       */
      allSelected: [],

      /**
       * Track modal is open?
       */
      isModalOpenAfterApplied: false,

      isLoading: false
    };
  },

  computed: {
    allSelectedCondition() {
      return this.allSelected.filter((selected) => selected.is_selected === true);
    },
    isSubCategoriesSelectedAll() {
      return this.allSelected.filter((sub_category) => sub_category.is_selected).length;
    },
    subCategories() {
      return this.categories.map((category) => {
        return category.sub_categories;
      });
    }
  },

  watch: {
    resetModal(resetModal) {
      if (resetModal) {
        this.resetData();
      }
    }
  },

  mounted() {
    this.fetchingCategories();
  },

  methods: {
    /**
     * Open modal
     */
    show(type) {
      this.modalType = type;
      this.$bvModal.show('modalFilterCategories');

      if (!this.filterCategories.length) {
        /**
         * if !filterCategories.length
         *
         * แสดงว่ายังไม่ได้มีการกด apply จะ reset ข้อมูลใหม่หมด
         */
        this.resetData();
      }

      /**
       * if allSelectedCondition === filterCategories
       *
       * It means already apply but didn't change filter when close modal
       */
      if (this.allSelectedCondition === this.filterCategories) {
        return;
      }

      /**
       * if allSelectedCondition !== this.filterCategories
       *
       * It means before close modal user change filter but didn't apply new one
       *
       * So, allSelectedCondition will remain the same when open modal
       */
      if (this.allSelectedCondition !== this.filterCategories) {
        /**
         * set is_selected to true only object that contain in filterCategories
         */
        this.filterCategories.forEach((sub_category) => {
          this.$set(sub_category, 'is_selected', true);
        });
        /**
         * filter sub category that not be in filterSubcategories
         *
         * Then set its is_selected value to false, to make allSelectedCondition computed show only previos applied
         */
        const filterOutSubCategory = this.allSelected.filter((selected) => {
          return !this.filterCategories.includes(selected);
        });
        filterOutSubCategory.forEach((sub_category) => {
          this.$set(sub_category, 'is_selected', false);
        });

        this.isModalOpenAfterApplied = true;

        /**
         * In case of open modal from Edit page
         */
        if (this.subCategoriesOld) {
          this.subCategoriesOld.forEach((sub_category) => {
            this.$set(sub_category, 'is_selected', true);
          });
        }
      }
    },

    hide() {
      this.$bvModal.hide('modalFilterCategories');
    },

    getSelectedSubCategoriesFromEmit(selectedSubCategories) {
      this.allSelected = [...this.allSelected, ...selectedSubCategories];
      this.allSelected = [...new Set(this.allSelected)];
    },

    submitFilterCategories() {
      this.$emit('confirmedFilter', this.allSelectedCondition);

      this.$bvModal.hide('modalFilterCategories');
    },

    /**
     * fetching categories from strapi
     */
    async fetchingCategories() {
      this.isLoading = true;

      let categoryResponse;
      categoryResponse = await Category.api().fetch();
      this.categories = categoryResponse.response.data;

      /**
       * Map only sub category name
       *
       * @return {Array}
       */
      const sub_category_name = this.categories.map((category) =>
        category.sub_categories.map((sub_category) => sub_category.name)
      );

      /**
       * Set key sub_categories_name from value above in object
       *
       * @type {Array}
       */
      this.categories.forEach((category, i) => {
        this.$set(this.categories[i], 'sub_categories_name', [...sub_category_name[i]]);
        this.$set(this.categories[i], `is_all_selected`, false);
        this.$set(this.categories[i], `indeterminate`, false);
        this.categories[i].sub_categories.forEach((sub_category, j) => {
          this.$set(this.categories[i].sub_categories[j], `is_selected`, false);
        });
      });

      this.isLoading = false;
    },

    resetIsModalOpenAfterApplied(v) {
      this.isModalOpenAfterApplied = v; // false
    },

    resetData() {
      this.allSelected = [];

      this.categories.forEach((category) => {
        category.sub_categories.forEach((sub_category) => (sub_category.is_selected = false));
      });
    }
  }
};
</script>
